module.exports = __webpack_public_path__ + "img/teacherLead-2.12b802d3.jpg";